import type { CustomizationSelection } from '../domain/models/CustomizationSelection';

export type CustomizationApiArgs = {
  designId: string;
} & CustomizationSelection;

export function buildCustomizationQueryString(args: CustomizationApiArgs): string {
  const { designId, ...params } = args;
  const base = `/product/${designId}/customization`;
  const queryParts: string[] = [];

  const entries: Array<[string, string | number | undefined]> = [
    ['customization_id', params.customization_id],
    ['metal_color', params.metal_color],
    ['metal_karatage', params.metal_karatage],
    ['diamond_type', params.diamond_type],
    ['solitaire_carat', params.solitaire_carat],
    ['solitaire_clarity', params.solitaire_clarity],
    ['solitaire_color', params.solitaire_color],
    ['solitaire_quality', params.solitaire_quality],
    ['size', params.size],
  ];

  for (const [key, value] of entries) {
    if (value != null && value !== '') {
      queryParts.push(`${key}=${encodeURIComponent(String(value))}`);
    }
  }

  return queryParts.length ? `${base}?${queryParts.join('&')}` : base;
}

export function selectionToApiParams(selection: CustomizationSelection): Omit<CustomizationApiArgs, 'designId'> {
  return {
    customization_id: selection.customization_id,
    metal_color: selection.metal_color,
    metal_karatage: selection.metal_karatage,
    diamond_type: selection.diamond_type,
    solitaire_carat: selection.solitaire_carat,
    solitaire_clarity: selection.solitaire_clarity,
    solitaire_color: selection.solitaire_color,
    solitaire_quality: selection.solitaire_quality,
    size: selection.size,
  };
}
